import { Dispatch, SetStateAction, useState } from 'react';
import ReactCodeInput from 'react-code-input';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Spinner from '../../../components/common/Spinner';
import { Button, SecurityCodeWrapper } from '../../../styles/GlobalComponents';
import { color } from '../../../styles/GlobalStyles';
import { FlexCenter } from '../../../styles/stylesStyled';
import { SubTitle, Title } from '../../Settings/SettingsStyled';
import { useAppSelector } from '../../../app/hooks';
import { HELPDESK } from '../../../routes/routes';
import { createWithdrawEmailExplorerVerification } from '../../Earnings/Withdraw/Withdraw.actions';
import { UserWalletModel } from '../../../types/wallets-types';

interface VerificationEmailProps {
  setAmount: Dispatch<SetStateAction<string>>;
  selected: number;
  userWallets: UserWalletModel[];
  amount: string;
}

export const VerificationEmail = ({
  amount,
  userWallets,
  selected,
  setAmount
}: VerificationEmailProps) => {
  const { t } = useTranslation('settings');
  const history = useHistory();
  const dispatch = useDispatch();
  const [code, setCode] = useState('');

  const { loading } = useAppSelector((state) => state.withdraw);

  return (
    <div style={{ marginTop: '20vh' }}>
      <FlexCenter style={{ flexDirection: 'column' }}>
        {loading ? (
          <Spinner />
        ) : (
          <>
            <Title>{t('security.verification_email_title')}</Title>
            <SubTitle style={{ textAlign: 'center' }}>
              {t('security.seven_digits')}
            </SubTitle>

            <SecurityCodeWrapper>
              <ReactCodeInput
                fields={7}
                value={code}
                onChange={setCode}
                type={'number'}
                name='ReactCodeInput'
                inputMode='numeric'
              />
            </SecurityCodeWrapper>

            <Button
              maxWidth='300px'
              h='50px'
              m={'30px 0 0 0'}
              disabled={code.length < 7}
              onClick={() => {
                dispatch(
                  createWithdrawEmailExplorerVerification({
                    amount: parseInt(amount),
                    userWalletId: userWallets[selected].id,
                    verificationCode: code,
                    setAmount
                  })
                );
              }}>
              {t('security.submit')}
            </Button>
            <SubTitle style={{ textAlign: 'center', marginTop: 12 }}>
              {t('security.verification_email_problems')}
              <span
                style={{ color: color.colors.secondary100, marginLeft: 5 }}
                onClick={() => history.push(HELPDESK)}>
                {t('security.contact_support')}
              </span>
            </SubTitle>
          </>
        )}
      </FlexCenter>
    </div>
  );
};
